function Reports() {
  return (
    <>
      <div className="font-bold text-lg mb-16">Reports</div>
    </>
  );
}

export default Reports;
